import BsPageHeader from './index.vue'
export default BsPageHeader